<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'新日清报表'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
          <div class="h-piece">
            <div class="h-formBox">
              <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="创客">
                    <el-input v-model="q.planUserName" placeholder="请输入创客名称"></el-input>
                  </el-form-item>

                <el-form-item label="单位名称">
                  <el-input v-model="q.customerName" placeholder="请输入创客名称"></el-input>
                </el-form-item>


                  <el-form-item label="是否日清">
                    <el-select filterable v-model="q.subStatus" clearable placeholder="请选择">
                      <el-option label="日清" value="1"></el-option>
                      <el-option label="未日清" value="0"></el-option>
                    </el-select>
                  </el-form-item>

                <el-form-item label="部门">
                  <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
                  >
                    <el-option
                        v-for="(item,index) in deptList"
                        :key="item.dept"
                        :label="item.dept"
                        :value="item.dept">
                    </el-option>
                  </el-select>
                </el-form-item>
                </div>
                <el-collapse-transition>
                  <div v-show="isScreen">
                  <div class="h-thirdColumn w-newColumn">
                      <el-form-item label="抢入链群" prop="lianqun">
                        <brselect category="xsyb_lianqun" :v="q.lianqunCode" :showcode="true"
                                  v-model="q.lianqunCode" clearable></brselect>
                      </el-form-item>
                      <el-form-item label="区域" prop="searchQuyu">
                        <brselect clearable category="show_area" :v="q.searchQuyu"
                                  v-model="q.searchQuyu"></brselect>
                      </el-form-item>
                      <el-form-item label="渠道类型">
                        <el-select filterable v-model="q.field" clearable placeholder="请选择">
                          <el-option label="医疗创新" value="1"></el-option>
                          <el-option label="生命科学" value="2"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="职位类型">
                        <el-select filterable v-model="q.titleCode" clearable placeholder="请选择">
                          <el-option label="大区经理" value="DAQU"></el-option>
                          <el-option label="渠道经理" value="QUDAO"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>

                    <div class="h-thirdColumn w-newColumn">
                      <el-form-item label="用户类型">
                        <el-select filterable v-model="q.isagent" clearable placeholder="请选择">
                          <el-option label="用户" value="0"></el-option>
                          <el-option label="经销商" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item class="h-elformWrap-1" label="拜访日期">
                        <el-col>
                          <el-date-picker
                              type="daterange"
                              v-model="times"
                              unlink-panels
                              range-separator="-"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd"
                              width="100%"
                          >
                          </el-date-picker>
                        </el-col>
                      </el-form-item>
                    </div>
                  </div>
                </el-collapse-transition>
              </el-form>

              <!--<div class="l-screenBox">-->
              <!--  <div class="l-retrieval">-->
              <!--    <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>-->
              <!--    <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>-->
              <!--  </div>-->
              <!--</div>-->

              <div class="l-screenBox">
                <div class="l-screen" @click="collapseChange">
                  <img :src="isScreen?closeScreen:drawScreen" alt="">
                  <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                </div>
                <div class="l-retrieval">
                  <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                  <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                </div>
              </div>

            </div>
          </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"

                    :data="tableData"
                    :border="true"
                    stripe
                    max-height="560"
                    style="width: 100%" >
                        <el-table-column
                            label="序号"
                            type="index"
                            width="50">
                        </el-table-column>
                        <el-table-column prop="quyuName" label="区域" width="80px" ></el-table-column>
                  <el-table-column prop="planUserNameDAQU"  label="大区经理" width="80px" ></el-table-column>
                  <el-table-column prop="planUserNameQUDAO"  label="渠道经理" width="80px" ></el-table-column>
                  <el-table-column prop="deptName"  label="部门" width="80px" ></el-table-column>
                  <el-table-column prop="planCreateTime" label="拜访日期" width="100px" ></el-table-column>
                  <el-table-column prop="lianqunName" label="抢入链群" width="80px" ></el-table-column>
                  <el-table-column prop="customerName" label="单位名称" width="150px" :show-overflow-tooltip="true" ></el-table-column>
                  <el-table-column prop="projectName" label="项目分类" width="100px" :show-overflow-tooltip="true" ></el-table-column>
                  <el-table-column prop="field" label="渠道类型" width="80px">
                    <template slot-scope="scope">
                      <span v-if="scope.row.field == '1'">
                        医疗创新
                      </span>
                      <span v-if="scope.row.field == '2'">
                         生命科学
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="isagent" label="用户类型" width="80px">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isagent == '1'">
                        经销商
                      </span>
                      <span v-if="scope.row.isagent == '0'">
                         用户
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="department" label="部门/科室" width="150px"  :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column prop="contactUserName" label="联系人" width="100px" ></el-table-column>
                  <el-table-column prop="telephone" label="电话" width="100px" ></el-table-column>
                  <el-table-column prop="visitContent" label="目标内容" width="150px" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column prop="dailyContent" label="日总结" width="150px" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column prop="sysScore" label="日评价" width="60px" ></el-table-column>
                </el-table>
            </div>

        </div>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL" style="margin-left: 23px">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel()">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>

    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import cost from '../../../routes/cost';
export default {
    data() {
        return {

          // 展开折叠筛选
          isScreen:false,
          closeScreen:require("@/assets/images/pimg/closeallic.png"),
          drawScreen:require("@/assets/images/pimg/dobleArr.png"),
            q:{
                visitDate:'',
                searchQuyu:'',
                subStatus:'',
                planUserName:'',
                customerName:'',
                lianqunCode:'',
                cdept:'',
                pageNo:1,
                pageSize:10,
                total:0,
            },
            size:'',
            tableData: [],
            times:[],
            newDialog:false,
            writeNissin:false,
            editDialog:false,

            yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
            weekList:[],
            nissin:{
              answerTime:'',
              defultFlag:'',
              dailyQuestion:'',
              customerName:'',
              visitDate:'',
              endDate:'',
              visitContent:"",
              dailyContent:'',
              isProject: 0,
              id:'',
              isConShow:false,
              isProjectBtn:false,
              chainGroupName:'',
              chainGroupCode:'',
              visitEffect:'',
              title:'',
              statusR:'',
              selectVisitEffect:['a','b'],
              gameTitles: [],
              subJieProgess: [], // 需求子节点数据
              childMsgId: '',
              //yucePrice: '', // 月预算在下单
              expConvDate: '',
              department:'',
              telephone:'',
              contactUserName:"",
              lianqunCode:'',
            },

            authTypeListEdit:[],
            wirteNissinList:[],
            disEdit:false,
            workList:[],
            deptList: [],
            AuthoCheck: '',
            authTypeList: [],
            userList: [0],
            weekPlanList:[],
            groupList: [],
            groupArr:[],
            titleDig:"",
            optionList:[],
            projectList:[],
        }
    },
    methods: {
        getOption(){
            this.optionList=[]
            var data  = ''
             ss.MuBiao.getUser(data).then(res => {
                console.log(res)
                this.optionList = res.msg
             })
        },
      //明细导出
      exportExcel() {
        updownfile.down("/api/swyl/v1/dailyClear/userDailyClear/downloadExcelNewDayClearPlan",this.q,"post",'data');
      },
        showFormList(value) {
            ss.MuBiao.getUser(value).then(res => {
                console.log(res)
                this.optionList = res.msg
            })
        },
        //项目类型
        getProject(){
            ss.MuBiao.getProject().then(res => {
                console.log(res)
                this.projectList = res.msg
            })
        },
        getDept(q){
          ss.MuBiao.getDeptList(q).then(rd => {
            this.deptList = rd;
          })
        },

        groupListMe() {
            var data  = this.add.customerName
             ss.MuBiao.getUser(data).then(res => {
                console.log(res)
                this.groupList = []
                this.groupArr = []
                this.groupList = res.msg
                for(let item of this.groupList) {
                    this.groupArr.push({
                        value:item.userName,
                        id:item.userCode
                    })
                }
             })
        },

      query(){
        if(this.times && this.times.length>0){
          this.q.dateS = this.times[0];
          this.q.dateE = this.times[1];
        }else{
          this.q.dateS = "";
          this.q.dateE = "";
        }
      this.selectPageAll()
      },
      selectPageAll(){
        ss.MuBiao.getDayClearPlan(this.q).then(res => {
          console.log(res.msg)
          this.tableData = res.records
          this.q.total = res.total
          //this.listProject = res.msg
        })
      },
        querySearchGroup(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup(val) {
            console.log(val)
             this.add.customerName= val.value
        },
        groupListMe1() {
            var data  = this.edit.customerName
             ss.MuBiao.getUser(data).then(res => {
                console.log(res)
                this.groupList = []
                this.groupArr = []
                this.groupList = res.msg
                for(let item of this.groupList) {
                    this.groupArr.push({
                        value:item.userName,
                        id:item.userCode
                    })
                }
             })
        },
        querySearchGroup1(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup1(val) {
            console.log(val)
             this.edit.customerName= val.value
        },
        getDefaultDate() {
          //获取新的时间(2019.4.12）
          let date = new Date()
          //获取当前时间的年份转为字符串
          let year = date.getFullYear().toString()   //'2019'
          //获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
          let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()  //'04'
          //获取天，判断是否小于10，如果是在字符串前面拼接'0'
          let da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()  //'12'
          //字符串拼接，开始时间，结束时间
          let end = year + '-' + month + '-' + this.getLastDate(year,month)  //当天'2019-04-12'
          let beg = year + '-' + month + '-01'   //当月第一天'2019-04-01'
          this.times = [beg, end] //将值设置给插件绑定的数据
        },
        getLastDate(iYear,iMonth){

          if (iMonth == '02')
            if (!iYear % '04')
              return 29;
            else return 28
          else if (iMonth == '04' || iMonth == '06' || iMonth == '09' || iMonth == 11)
            return 30;
          else  return 31;
        },

        changeHandler(value) {
            //console.log('改变之后的值是:' + value)
            let data =  this.authTypeList
            let item = this.add.userList
　　　　　　 // 使用find方法根据id查询对应对象
            let a =  data.find((ele)=>{
                return ele.id == item
            });
            console.log(a) //1
            var arr3 =a
            if(!arr3.id){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    this.add.clearType = 2
                    this.disEdit = true
                }else{
                    this.add.targetContent = arr3.targetContent,
                    this.add.customerName= arr3.customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3.projectName
                    this.disEdit = false
                    this.add.id = this.add.userList
                }
        },
      handleFilter() {
        this.query();
      },
        groupChange() {
            console.log("变化", this.add.userList);
            if (this.add.userList.length > 1) {
                this.add.userList.shift();
            }
            console.log(this.add.userList)
            var arr3 =[]
                this.add.userList.forEach((item) => {
					this.authTypeList.forEach((element) => {
						  if (item == element.id) {
							arr3.push(element)
						  }
					})
                })
                console.log(arr3)
                if(arr3.length == 0){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    //
                    //this.add.visitDateNew= ''
                    this.add.clearType = 2
                    this.disEdit = false
                }else{
                    this.add.targetContent = arr3[0].targetContent,
                    this.add.customerName= arr3[0].customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3[0].projectName
                    this.disEdit = true
                    this.add.id = this.add.userList[0]
                }
        },

        //获得周计划列表
        getWeekPlan(year,week){
            var year = this.add.year
            var week = parseInt(this.add.week)
            var data = {
                year:year,
                week:week
            }
            console.log(data)
            ss.MuBiao.getListPlan(data).then(res => {
                console.log(res)
                if(res.f == true ){
                    console.log(res)
                    this.authTypeList = res.msg
                }else{
                    this.$message.error(res.msg);
                }
            })
        },

        getNowTime() {
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth(); //得到月份
            var date = now.getDate(); //得到日期
            month = month + 1;
            month = month.toString().padStart(2, "0");
            date = date.toString().padStart(2, "0");
            var defaultDate = `${year}-${month}-${date}`;
            this.$set(this.q, "visitDate", defaultDate);
            this.$set(this.add, "visitDateNew", defaultDate);
        },

        getWeeks(y){
            ss.MuBiao.getWeekList({year:y}).then(rd => {
                this.weekList = rd;
            })
        },
        getWeeksBySelectYear(){
            this.getWeeks(this.add.year);
            ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                this.addlianqunList = rd;
            })
        },
        selectWeek(){
            console.log(this.add.week)
            this.getWeekPlan()
        },
        getqWeeksBySelectYear(){
            this.getqWeeks(this.q.year,1);
        },
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        rest(){
            var pageSize=this.q.pageSize;
            var pageNo=this.q.pageNo;
            var total=this.q.total;
            this.q= {
                pageSize: pageSize,
                pageNo: pageNo,
                total:total,
                visitDate:'',
                subStatus:'',
                planUserName:'',
                customerName:'',
                lianqunCode:'',
                cdept:'',
            }
        },
        exit(){
            this.closeDialog()
        },
        closeDialog(){
            this.newDialog = false
            this.editDialog = false
            this.writeNissin = false
            this.xxx = '';//清空数据

            this.add.targetContent='',
            this.add.customerName='',
            this.add.visitDateNew='',
            this.add.clearType='2',
            this.add.projectName=''

            this.edit.targetContent='',
            this.edit.customerName='',
            this.edit.visitDateNew='',
            this.edit.projectName=''

        },
    },
    watch:{
        'add.customerName': {
            deep: true,
            handler: function (newVal,oldVal){
            this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
            var len = this.groupList.length;//groupList
            var arr = [];
            for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
                arr.push({
                    value:this.groupList[i].name,
                    id:this.groupList[i].id
                })
                }
            }
            this.groupArr = arr
            }
        },
    },
    created(){
        //先进行获取时间
        this.getDefaultDate();
        //然后再由times[0] 给
        this.query();
        this.getWeeks(new Date().getFullYear());
        this.getOption()
        this.getProject()
        this.getDept();

    }
}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:80px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    /deep/ .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }

    .projectCon p{
      justify-content: space-between;
      align-items:center;
      font-size: 14px;
      border-bottom:#1b78e6 1px dashed;
      padding: 5px 0;
      margin: 0 auto 10px auto;
      color: #1b78e6;
    }
</style>
